import styled from '@emotion/styled'
import {theme} from '../../../../theme'

// Drawer Shell

export const DrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  gap: 10px;
`

// Header

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 20px 0;
  border-bottom: 1px solid #e2e8f0;
`

export const DrawerHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[4]};
`

export const DrawerIconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-color: #f4f6fb;
`

export const DrawerTitleGroup = styled.div`
  display: flex;
  flex-direction: column;
`

export const DrawerLabel = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: #627185;
  letter-spacing: 0.3;
  text-transform: uppercase;
`

export const DrawerTitle = styled.p`
  margin: 0;
  font-size: 18px;
  font-weight: ${theme.fontWeights.bold};
  color: #0f172a;
`

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  opacity: 70%;
`

// Body

export const DrawerBody = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const SectionTitle = styled.p`
  font-size: 12px;
  font-weight: ${theme.fontWeights.bold};
  color: #050505;
  margin: 0;
`

export const SectionBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  background-color: #f1f5ff;
  border-radius: 12px;
`

export const DetailRowWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #f1f5ff;
  border-radius: 12px;
  gap: 16px;
  &:not(:last-child) {
    border-bottom: 1px solid ${theme.colors.border.light};
  }
`

export const DetailIconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-color: #dfe5f7;
`

export const DetailContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const DetailLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #627185;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`

export const DetailValue = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
`
